"use client";

import { useEffect } from "react";
import { primeConcurrencyCapability } from "@/lib/webgl-capability";

// Mounted once in the root layout (every page, not just /customize) so the WebGL concurrency check has
// already resolved by the time a shopper actually reaches /customize, rather than being computed fresh
// on that page's own mount -- explicit request. Renders nothing; primeConcurrencyCapability itself is
// idempotent (a plain module-level check, see lib/webgl-capability.ts), so this is safe to mount
// alongside a page that also happens to trigger the same prime call directly.
export function WebglCapabilityPrimer() {
  useEffect(() => {
    primeConcurrencyCapability();
  }, []);
  return null;
}
